function toHexChannel(value) {
  return Math.max(0, Math.min(255, Number(value))).toString(16).padStart(2, '0');
}

function fromRgbObject(color) {
  if (!color || typeof color !== 'object') {
    return null;
  }
  if (typeof color.r === 'number' && typeof color.g === 'number' && typeof color.b === 'number') {
    return `#${toHexChannel(color.r)}${toHexChannel(color.g)}${toHexChannel(color.b)}`.toUpperCase();
  }
  return null;
}

export function normalizeHexColor(color, fallback = '#FFFFFF') {
  if (color == null || color === '') {
    return fallback;
  }
  const rgbObject = fromRgbObject(color);
  if (rgbObject) {
    return rgbObject;
  }
  const value = String(color).trim();
  if (/^#[0-9A-Fa-f]{8}$/.test(value)) {
    return value.slice(0, 7).toUpperCase();
  }
  if (/^#[0-9A-Fa-f]{6}$/.test(value)) {
    return value.toUpperCase();
  }
  if (/^[0-9A-Fa-f]{6}$/.test(value)) {
    return `#${value.toUpperCase()}`;
  }
  const rgb = value.match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
  if (rgb) {
    return `#${toHexChannel(rgb[1])}${toHexChannel(rgb[2])}${toHexChannel(rgb[3])}`.toUpperCase();
  }
  return fallback;
}

export function normalizeStrokeHexColor(color) {
  return normalizeHexColor(color, '#000000');
}
